import React from "react";
import Socials from "./socials";

export default function Footer(){
    const year = new Date().getFullYear();
    return(
        <footer>
            <Socials />
            <div className="detail">
                <span className="copyright"> &copy; {year} </span>
                <span className="footerName">Manpreet Kaur</span>
            </div>
        </footer>
    )
}